import { Box, Icon, Loader, Spacer } from '@jfs/ui-new'
import { FC, useEffect } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { ApprovalTypes } from '../../utils/constants'
import { styles } from './styles/MasterApprovalsStyles'

interface ApprovalOrDeclineProps {
  type: string
  approvalId: string
  approvalType: string
  onSuccess: () => void
  username?: string
}

const ApprovalOrDecline: FC<ApprovalOrDeclineProps> = (props: ApprovalOrDeclineProps) => {
  const { type, approvalId, approvalType, onSuccess, username } = props

  const {
    enttityApproval,
    cardApproval,
    merchantApproval,
    netbankingApproval,
    packageApproval,
    package2InApproval,
    package2MidApproval,
    routingApproval,
    fileApproval,
    bankCodeApproval,
    feePackageApproval,
    feePackageMidApproval,
    feePackageFileApproval,
    merchantPayoutConfigApproval,
    crDrApproval,
    payoutCmsApproval,
    riskConfigTxnApproval,
    riskConfigMidApprovals,
    loggedInUserName,
    setMessage,
  } = useStores((store) => ({
    enttityApproval: store.entityMaster.processApprovals,
    cardApproval: store.card.processApprovals,
    merchantApproval: store.merchantMapping.processApprovals,
    netbankingApproval: store.netBanking.processApprovals,
    packageApproval: store.package.processApprovals,
    package2InApproval: store.packageToInstrument.processApprovals,
    package2MidApproval: store.packageToMId.processApprovals,
    routingApproval: store.routingRule.processApprovals,
    fileApproval: store.fileUpload.processApprovals,
    bankCodeApproval: store.bankingCode.processApprovals,
    feePackageApproval: store.feePackage.processApprovals,
    feePackageMidApproval: store.feePackageToMId.processApprovals,
    feePackageFileApproval: store.feePackageFileUpload.processApprovals,
    merchantPayoutConfigApproval: store.merchantPayoutConfig.processApprovals,
    crDrApproval: store.creditAdjustment.processApprovals,
    payoutCmsApproval: store.payoutCms.processApprovals,
    riskConfigTxnApproval: store.riskConfig.processApprovals,
    riskConfigMidApprovals: store.riskConfig.processApprovalsMid,
    loggedInUserName: store.user.name,
    setMessage: store.message.setMessage,
  }))

  const getApprovalApi = (type: string) => {
    const getApi = {
      [ApprovalTypes.ENTITY]: enttityApproval,
      [ApprovalTypes.CARDMAPPING]: cardApproval,
      [ApprovalTypes.NETBANKING]: netbankingApproval,
      [ApprovalTypes.MERCHANT]: merchantApproval,
      [ApprovalTypes.ROUTING]: routingApproval,
      [ApprovalTypes.PACKAGE]: packageApproval,
      [ApprovalTypes.PACKAGE_INSTRUMENT]: package2InApproval,
      [ApprovalTypes.PACKAGE_MID]: package2MidApproval,
      [ApprovalTypes.GENERATE_EXCEL_FILE]: fileApproval,
      [ApprovalTypes.BANKING_CODE]: bankCodeApproval,
      [ApprovalTypes.FILE_ROUTING]: fileApproval,
      [ApprovalTypes.FEE_PACKAGE]: feePackageApproval,
      [ApprovalTypes.FEE_PACKAGE_MID]: feePackageMidApproval,
      [ApprovalTypes.FEE_PACKAGE_FILE_UPLOAD]: feePackageFileApproval,
      [ApprovalTypes.MERCHANT_PAYOUT]: merchantPayoutConfigApproval,
      [ApprovalTypes.CREDIT_ADJUSTMENT]: crDrApproval,
      [ApprovalTypes.PAYOUT_CMS]: payoutCmsApproval,
      [ApprovalTypes.RISK_CONFIG_TXNS]: riskConfigTxnApproval,
      [ApprovalTypes.RISK_CONFIG_MID]: riskConfigMidApprovals,
    }
    return getApi[type]
  }

  const [lazyApproval, lazyApprovalHandler] = useLazyApiData(getApprovalApi(type))

  useEffect(() => {
    if (lazyApprovalHandler.state === 'fulfilled') {
      onSuccess()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyApprovalHandler])

  const onPress = (isApproved: boolean) => {
    if (['CREDIT_ADJUSTMENT', 'PAYOUT_CMS'].includes(type) && loggedInUserName === username) {
      setMessage('Logged in user and Checker can not be same')
    } else {
      lazyApproval({
        id: approvalId,
        type: approvalType,
        status: isApproved,
      })
    }
  }

  return (
    <Box>
      {lazyApprovalHandler.state === 'pending' ? (
        <Box pb={20}>
          <Loader />
        </Box>
      ) : (
        <Box {...styles.approvalWrapper}>
          <Box {...styles.roundedAction({ isActive: true })} onPress={() => onPress(true)}>
            <Icon id="TICKMARK" size={20} color="WHITE" />
          </Box>
          <Spacer direction="horizontal" size={40} />
          <Box {...styles.roundedAction({ isActive: false })} onPress={() => onPress(false)}>
            <Icon id="CLOSE" size={20} color="WHITE" />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export { ApprovalOrDecline }
